<script>
	import { query } from "sinao-corejs";
	import { mapState } from "vuex";
	import i18n from "@/i18n";
	import onboardingPopoverMixin from "@/mixins/onboardingPopoverMixin";

	export default {
		mixins: [onboardingPopoverMixin],
		props: {
			status: {
				type: Boolean,
				required: true,
				default: false
			}
		},
		data() {
			return {
				modalRefName: "ModalBankAccountCreate",
				name: "",
				iban: "",
				bic: "",
				loading_submit: false
			};
		},
		computed: {
			...mapState({
				appId: state => state.app.id
			})
		},
		mounted() {
			this.$refs[this.modalRefName].$on("shown", () => this.onModalShow());
			this.$refs[this.modalRefName].$on("hidden", () => {
				this.onModalHidden();
				this.$emit("update:status", false);
			});
		},
		methods: {
			handleOk(bvModalEvt) {
				// Prevent modal from closing
				bvModalEvt.preventDefault();

				this.handleSubmit();
			},
			async handleSubmit() {
				// Exit when the form isn't valid
				if (!this.$refs.form.checkValidity() || this.loading_submit || this.name.length == 0 || this.iban.length == 0 || this.bic.length == 0) {
					this.$bvToast.toast(i18n.t("Veuillez remplir tous les champs"), {
						title: i18n.t("Ajouter un RIB"),
						variant: "warning",
						solid: true
					});
					return;
				}

				this.loading_submit = true;

				if (this.appId === 0) {
					this.$store.commit("bankdetails", {
						name: this.name,
						iban: this.iban,
						bic: this.bic,
						new: true
					});
				} else {
					await query({
						operationId: "app.documents.sales.bankdetails.create",
						params: {
							appId: this.appId
						},
						data: {
							name: this.name,
							iban: this.iban,
							bic: this.bic
						}
					});

					this.$store.dispatch("bankdetails", this.appId);
				}

				this.loading_submit = false;
				this.$bvToast.toast(i18n.t("Votre RIB a été enregistré avec succès"), {
					title: i18n.t("Ajouter un RIB"),
					variant: "success",
					solid: true
				});

				// Reset the form
				this.name = "";
				this.iban = "";
				this.bic = "";

				// Hide the modal manually
				this.$emit("update:status", false);
			}
		}
	};
</script>

<template>
	<b-modal
		:ref="modalRefName"
		:visible="status"
		:title="$t('Ajouter un RIB')"
		:ok-only="true"
		@ok="handleOk"
	>
		<form
			ref="form"
			@submit.stop.prevent="handleSubmit"
		>
			<b-row class="pl-4 pr-4">
				<b-col>
					<label>{{ $t("Libellé") }}</label>
					<b-form-input
						v-model="name"
						size="sm"
						:placeholder="$t('Libellé du compte')"
					/>
				</b-col>
			</b-row>
			<b-row class="mt-4 pl-4 pr-4">
				<b-col>
					<label>{{ $t("IBAN") }}</label>
					<b-form-input
						v-model="iban"
						size="sm"
						:placeholder="$t('IBAN')"
					/>
				</b-col>
			</b-row>
			<b-row class="mt-4 pl-4 pr-4">
				<b-col>
					<label>{{ $t("BIC/SWIFT") }}</label>
					<b-form-input
						v-model="bic"
						size="sm"
						:placeholder="$t('BIC/SWIFT')"
					/>
				</b-col>
			</b-row>
		</form>

		<template #modal-footer>
			<s-button type="success" @click="handleSubmit"> {{ $t("Créer le RIB") }} </s-button>
		</template>
  	</b-modal>
</template>

<style></style>
